import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter, Link} from 'react-router-dom';
import {signinUser} from '../actions';
import {toggleDrawer, switchDrawer} from '../../Layout/actions';
import LoadingSpinner from '../../Layout/components/LoadingSpinner';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import {trackUser} from 'react-with-analytics';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../translations/translations_signindrawer';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class SigninDrawer extends Component {
    state = {
        errors: {},
        email: '',
        password: '',
        showPassword: false,
        dialogPendingSignupOpen: false,
        dialogAccountDisabledOpen: false,
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.errors !== this.props.errors) {
            const errorsData = (this.props.errors.hasOwnProperty('data')) ? this.props.errors.data : {};
            const errorCode = (this.props.errors.hasOwnProperty('code')) ? this.props.errors.code : '';

            const pendingSignup = (errorCode === 'pending_signup' && errorsData.status === 403);
            const accountDisabled = (errorCode === 'account_disabled' && errorsData.status === 403);

            if (pendingSignup || accountDisabled) {
                this.props.toggleDrawer('signin', false);

                this.setState({
                    errors: this.props.errors,
                    dialogPendingSignupOpen: pendingSignup,
                    dialogAccountDisabledOpen: accountDisabled,
                    email: '',
                    password: '',
                });
            } else {
                this.setState({
                    errors: this.props.errors,
                    dialogPendingSignupOpen: false,
                    dialogAccountDisabledOpen: false,
                });
            }
        }

        if (prevProps.auth.isAuthenticated !== this.props.auth.isAuthenticated) {
            if (this.props.auth.isAuthenticated) {
                trackUser(this.props.auth.user.id);
            }
        }
    }

    toggleDrawer = (drawer, open) => (e) => {
        e.preventDefault();

        this.props.toggleDrawer(drawer, open);
    };

    switchDrawer = (drawerToClose, drawerToopen) => (e) => {
        e.preventDefault();

        this.props.switchDrawer(drawerToClose, drawerToopen);
    };

    handleFormSubmit = e => {
        e.preventDefault();

        const userData = {
            email: this.state.email,
            password: this.state.password,
        };

        this.props.signinUser(userData);
    };

    handleChange = name => e => {
        this.setState({
            [name]: e.target.value,
        });
    };

    handleMouseDownPassword = e => {
        e.preventDefault();
    };

    handleClickShowPassword = () => {
        this.setState(state => ({showPassword: !state.showPassword}));
    };

    handleCloseDialog = () => {
        this.setState({
            dialogPendingSignupOpen: false,
            dialogAccountDisabledOpen: false,
        });
    };

    render() {
        const {signinLoading} = this.props.auth;
        const {errors} = this.state;
        const errorsData = (errors.hasOwnProperty('data')) ? errors.data : {};

        return (
            <Fragment>
                <Drawer anchor="right" open={this.props.layout.signinDrawerOpen} onClose={this.toggleDrawer('signin', false)} id="signin-drawer" className="header-drawer" classes={{
                    paper: 'header-drawer-paper full',
                }}>
                    <div className="wrapper">
                        <div className="inner">
                            <div className="drawer-title">
                                <span className="section"><Translate id="auth_signin_drawer.espace_personnel" /></span>
                                <h2 className="title"><Translate id="auth_signin_drawer.title_connexion" /></h2>
                                <Button size="large" className="btn-close-drawer" onClick={this.toggleDrawer('signin', false)}>
                                    <CloseIcon className="m-icon"  />
                                </Button>
                                <div className="description">
                                    <p><Translate id="auth_signin_drawer.bienvenue_message" /></p>
                                </div>
                            </div>
                            <form id="signin-form" className="white-form" noValidate onSubmit={this.handleFormSubmit}>
                                <FormControl className="form-control" fullWidth={true} error={errorsData.email ? true : false}>
                                    <InputLabel htmlFor="email" className="form-label" style={{ fontSize: "20px" }}>
                                        <Translate id="auth_signin_drawer.field_email" />
                                    </InputLabel>
                                    <Input id="email" value={this.state.email} onChange={this.handleChange('email')} className="form-input" />
                                    {errorsData.email && (<FormHelperText id="email-error-text" className="form-helper">{this.props.translate('auth_signin_drawer.' + errorsData.email)}</FormHelperText>)}
                                </FormControl>
                                <FormControl className="form-control" fullWidth={true} error={errorsData.password ? true : false}>
                                    <InputLabel htmlFor="password" className="form-label">
                                        <Translate id="auth_signin_drawer.field_password" />
                                    </InputLabel>
                                    <Input id="password" value={this.state.password} type={this.state.showPassword ? 'text' : 'password'} className="form-input"
                                        onChange={this.handleChange('password')}
                                        endAdornment={
                                           <InputAdornment position="end">
                                               <IconButton
                                                   className="icon-button"
                                                   aria-label="Toggle password visibility"
                                                   onClick={this.handleClickShowPassword}
                                                   onMouseDown={this.handleMouseDownPassword}
                                               >
                                                   {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                               </IconButton>
                                           </InputAdornment>
                                       }
                                    />
                                    {errorsData.password && (<FormHelperText id="password-error-text" className="form-helper">{this.props.translate('auth_signin_drawer.' + errorsData.password)}</FormHelperText>)}
                                </FormControl>
                                {signinLoading ? (
                                    <LoadingSpinner color="inherit" align="center" />
                                ) : (
                                    <Fragment>
                                        <div className="row row-buttons">
                                            <div className="col col-lg-6 col-md-12">
                                                <Button className="mobile-button" variant="contained" size="large" fullWidth={true} id="btn-submit" type="submit" disabled={signinLoading}>
                                                    <Translate id="auth_signin_drawer.button_signin" />
                                                </Button>
                                            </div>
                                            <div className="col col-lg-6 col-md-12">
                                                <Button className="mobile-button" variant="outlined" size="large" fullWidth={true} id="btn-signup" onClick={this.switchDrawer('signin', 'signup')}>
                                                    <Translate id="auth_signin_drawer.button_signup" />
                                                </Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col col-12 text-center">
                                                <a id="btn-forgot-password" onClick={this.switchDrawer('signin', 'forgotPassword')}>
                                                    <Translate id="auth_signin_drawer.button_password_forgotten" />
                                                </a>
                                            </div>
                                        </div>
                                    </Fragment>
                                )}
                            </form>
                        </div>
                    </div>
                </Drawer>
                <Dialog
                    className="dialog-pending-signup"
                    open={this.state.dialogPendingSignupOpen}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.handleCloseDialog}
                    aria-labelledby="dialog-pending-signup-title"
                    aria-describedby="dialog-pending-signup-description"
                >
                    <DialogTitle id="dialog-pending-signup-title">
                        <Translate id="auth_signin_drawer.modal_pending_signup_title" />
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="dialog-pending-signup-description">
                            <span className="title"><Translate id="auth_signin_drawer.modal_pending_signup_subtitle1" /></span>
                            <Translate id="auth_signin_drawer.modal_pending_signup_desc1" />
                            <br />
                            <br />
                            <span className="title"><Translate id="auth_signin_drawer.modal_pending_signup_subtitle2" /></span>
                            <Translate id="auth_signin_drawer.modal_pending_signup_desc2" /> <Link to={this.props.translate('routes.contact')}><Translate id="auth_signin_drawer.modal_pending_signup_contact" /></Link>.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseDialog} color="primary">
                            <Translate id="auth_signin_drawer.modal_close" />
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    className="dialog-account-disabled"
                    open={this.state.dialogAccountDisabledOpen}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.handleCloseDialog}
                    aria-labelledby="dialog-account-disabled-title"
                    aria-describedby="dialog-account-disabled-description"
                >
                    <DialogTitle id="dialog-account-disabled-title">
                        <Translate id="auth_signin_drawer.modal_account_disabled_title" />
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="dialog-account-disabled-description">
                            <Translate id="auth_signin_drawer.modal_account_disabled_desc" /> <Link to={this.props.translate('routes.contact')}><Translate id="auth_signin_drawer.modal_account_disabled_contact" /></Link>.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseDialog} color="primary">
                            <Translate id="auth_signin_drawer.modal_close" />
                        </Button>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
    }
}

SigninDrawer.propTypes = {
    toggleDrawer: PropTypes.func.isRequired,
    switchDrawer: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    errors: state.auth.signinErrors,
    layout: state.layout,
});

export default withRouter(connect(mapStateToProps, {signinUser, toggleDrawer, switchDrawer})(withLocalize(SigninDrawer)));



// WEBPACK FOOTER //
// ./src/features/Auth/components/SigninDrawer.js